import { getCurrencyMinorUnits } from "../currency/currencyPrecision";

export const isSelectableReservationExtra = (extra) => {
  const amount = Number(extra?.amount);
  return Boolean(
    extra &&
      extra.scope !== "per_reservation" &&
      extra.is_active !== false &&
      extra.inclusive !== true &&
      Number.isFinite(amount) &&
      Math.round(amount * 100) !== 0
  );
};

export const getSelectableReservationExtras = (extras = []) =>
  (Array.isArray(extras) ? extras : []).filter(isSelectableReservationExtra);

export const buildReservationExtrasAssignmentPayload = (extras = []) => ({
  extras: getSelectableReservationExtras(extras).map((extra) => ({
    extra_id: extra.id,
    ...(extra.charge_period === "per_night" ? {
      selected_stay_dates: Array.isArray(extra.selected_stay_dates)
        ? [...extra.selected_stay_dates].sort()
        : null,
    } : {}),
  })),
});

export const getReservationExtraStayDates = (checkIn, checkOut) => {
  const start = String(checkIn || "").slice(0, 10);
  const end = String(checkOut || "").slice(0, 10);
  const startTime = Date.parse(`${start}T00:00:00Z`);
  const endTime = Date.parse(`${end}T00:00:00Z`);
  if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || endTime <= startTime) return [];
  const dates = [];
  for (let time = startTime; time < endTime; time += 86400000) {
    dates.push(new Date(time).toISOString().slice(0, 10));
  }
  return dates;
};

export const formatReservationExtraCatalogAmount = (
  extra,
  fallbackCurrency = "EUR",
  currencyCatalog = []
) => {
  if (!extra) return "";
  if (extra.amount_type === "relative") return `${extra.amount}%`;

  const currency = String(extra.currency || fallbackCurrency || "EUR")
    .trim()
    .toUpperCase();
  return `${Number(extra.amount).toFixed(getCurrencyMinorUnits(currency, currencyCatalog))} ${currency}`;
};
